import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import PriceCard from './Elements/PriceCard';
import { useSelector } from 'react-redux';
import BaseService from 'services/base/base.service';

function PlansWidget(props) {
    const { t } = useTranslation();
    const auth = useSelector(store => store.auth);
    const [activePeriod, setActivePeriod] = React.useState("monthly");
    const [subscriptionid, setSubscriptionid] = useState(null);
    let { prices } = props;

    const element = {
        "monthly": "0",
        "semestral": "1",
        "yearly": "2"
    }
    
    useEffect(() => {
        if (auth) {
            BaseService.getSubscriptionid()
                .then(res => {
                    setSubscriptionid(res?.data?.subscription)
                })
                .catch(err => {})
        }
    }, [])

    const checkedElement = (index) => {
        return element[index]
    }

    if (Object.keys(prices).length === 0) return null

    return (
        <div className="container-xl row mx-auto p-0 mt-4 mb-5">
            <div className="col-12 mb-72 mb-xs-40">
                <div className={"slider w-100 d-flex justify-content-between align-items-center mx-auto qty-" + (Object.keys(element).length - 1)}>
                    {
                        Object.keys(prices).map((period, index) => {
                            return (
                                <button key={"pb" + index} data-test-id={"plan-" + period} className={"slider-item text-white text-small text-bold p-0" + ((activePeriod === period) ? " isActive" : "")} onClick={() => { setActivePeriod(period) }}>
                                    {t("plan_period_" + period + "_label")}
                                </button>
                            )
                        })
                    }
                    <span className={"slider-runner d-block position-" + checkedElement(activePeriod)}></span>
                </div>
            </div>
            <div className="col-12 plans d-flex justify-content-between flex-wrap">
                {
                    Object.values(prices[activePeriod]).map((item, index) => {
                        return (
                            <div key={index} className={"plans-item text-center px-2 py-3 mx-auto mx-sm-0" + (item?.best ? " best-value" : "")}>
                                <PriceCard subscriptionid={subscriptionid} plan={item} />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

PlansWidget.propTypes = {
    prices: PropTypes.object
};

export default PlansWidget;
